// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { FirstBetIcon } from '../../assets/img/betting';
import { Target } from '../../client';
import Formatter from '../../i18n/formatter';
import { getCurrency } from '../../i18n/l10n';
import { __ } from '../../i18n/l10n';
import colors from '../../styled-components/palette';

const Wrap = styled.div`
  position: relative;
  background: ${colors.red200};
  border-radius: 0.4em;
  cursor: pointer;

  ${Target.__MOBILE__
    ? css`
        width: calc(100% - 40px);
        margin: 0 0 0 20px;
      `
    : css`
        width: calc(100% - 20px);
        margin: 0 0 0 10px;
      `}
`;

const Image = styled.img`
  width: auto;
  height: 110%;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
`;

const P = styled.p`
  position: relative;
  z-index: 2;
  color: #fff;
  width: 50%;
  padding: 1em;
  line-height: 1;
  user-select: none;
`;

const Span = styled.span``;

const Until = styled(Span)`
  margin-right: 0.2em;
`;

const Amount = styled(Span)`
  font-size: 3em;
  font-weight: bold;
`;

const Offer = styled(Span)`
  font-size: 3em;
  font-weight: bold;
  text-transform: uppercase;
`;

const Deposit = styled(Span)``;

type Props = {
  className?: string;
  onClick?: () => void;
};

const PPROffer = ({ className, onClick = () => {} }: Props) => {
  return (
    <Wrap className={className} onClick={onClick}>
      <P>
        <Until>{__('up to')}</Until>
        <Amount>{Formatter.formatNumber(200, getCurrency(), false, true)}</Amount>
        <br />
        <Offer>{__('free')}</Offer>
        <br />
        <Deposit>{__('with your next deposit')}</Deposit>
      </P>
      <Image src={FirstBetIcon} />
    </Wrap>
  );
};

export default PPROffer;
